export default __webpack_public_path__ + "static/media/logo_cavali.23b4357c.svg";